module.exports = __webpack_public_path__ + "static/progressBg-e286d879ce60ffdac68a42e94f5aa2d5.jpg";